{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".BEf_slid");
      MultipleSliders.forEach((slider, index) => {
        const pagin = slider.parentElement.querySelector(".swiper-pagination");
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          // grabCursor: true,
          allowTouchMove: false,
          speed: 1000,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          pagination: {
            paginationClickable: true,
            el: pagin,
            clickable: true,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 1,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".videos_sliders");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".videoSlidePrev");
        const nextArrow = slider.parentElement.querySelector(".videoSlideNext");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          // grabCursor: true,
          allowTouchMove: false,
          speed: 1000,
          navigation: {
            nextEl: ".videoSlideNext",
            prevEl: ".videoSlidePrev",
          },
          breakpoints: {
            150: {
              slidesPerView: 1.8,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.4,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 2.8,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".textRevOthSecWrapper .swiper");
      MultipleSliders.forEach((slider, index) => {
        const pagin = slider.parentElement.querySelector(".swiper-pagination");
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          // grabCursor: true,
          allowTouchMove: false,
          speed: 1000,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          pagination: {
            paginationClickable: true,
            el: pagin,
            clickable: true,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.3,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".why-choose-video-row.cols-2 .videos_sliders");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          // grabCursor: true,
          allowTouchMove: false,
          speed: 1000,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.8,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.4,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".products__section");

  sections.forEach((section) => {
    const slider = section.querySelector(".Products__lists");

    if (!slider) return;

    const prevArrow = section.querySelector(".prev");
    const nextArrow = section.querySelector(".next");

    new Swiper(slider, {
      direction: "horizontal",
      speed: 1000,

      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },

      breakpoints: {
        150: {
          slidesPerView: 1.1,
          spaceBetween: 20,
        },

        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },

        769: {
          slidesPerView: 2,
          spaceBetween: 20,
        },

        1025: {
          slidesPerView: 3,
          spaceBetween: 30,
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".testimonialSecN");

  sections.forEach((section) => {
    const slider = section.querySelector(".testiMonialSlider");

    if (!slider) return;

    const prevArrow = section.querySelector(".prev");
    const nextArrow = section.querySelector(".next");

    new Swiper(slider, {
      direction: "horizontal",
      speed: 1000,

      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },

      breakpoints: {
        150: {
          slidesPerView: 1,
          spaceBetween: 20,
        },

        576: {
          slidesPerView: 2,
          spaceBetween: 15,
        },

        769: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },

        1025: {
          slidesPerView: 3,
          spaceBetween: 30,
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
});